import axios from 'axios'
import { checkStatus, parseJSON } from './responseHandler'
import { BASE_API_URL } from '../utils/constant'
import Vue from 'vue'
import VueCookie from 'vue-cookie'


Vue.use(VueCookie);
// Make an api call

export default async(url, method = 'post', body) => {
    let headers = {
        'Content-Type': method === 'get' ? '' : 'application/json',
        'X-Auth-Id': VueCookie.get('X-Auth-Id'),
        'X-AUTH-TOKEN': VueCookie.get('X-Auth-Token')
    }
    return axios(`${BASE_API_URL}${url}`, {
            method,
            data: body ? JSON.stringify(body) : null,
            headers: headers
        })
        .then(checkStatus)
        .then(parseJSON)
        .catch(error => {
            throw error
        })
}